import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DropdownInput from 'screens/components/basic/DropdownInput';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "InventorySnapShot";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: []
        };

    }

    render() {
        const props = this.props;
        return (
            <CardSimple className="p-1">
                <div className="row row_margin_none">
                    <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.selectedDate.name}
                            floatingLabelText={LOOKUP.report.common.selectedDate.label + "*"}
                            hintText={LOOKUP.report.common.selectedDate.label + "*"}
                            fullWidth={true}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                        <BranchMultiSelectAutoCompleteInput
                            defaultValues={props.loggedBranch.toString()}
                            // name={componentName + LOOKUP.report.common.branchName}
                            name={`${componentName}Locations`}
                            label={LOOKUP.report.common.branch}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <SelectInput
                            name={componentName + "IsCannabis"}
                            fullWidth={true}
                            defaultValue="2"
                            label={"Type"}
                            floatingLabelText={"Type"}
                            hintText={"Type"}
                            options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <SelectInput
                            name={componentName + "SelectedCategory"}
                            fullWidth={true}
                            label={"Category"}
                            floatingLabelText={"Category"}
                            hintText={"Category"}
                            defaultValue={"0"}
                            options={props.categories && props.categories.length > 0 ? (this.props.isCannabis == 0 ? props.categories.filter(x => !x.isCannabis) : (this.props.isCannabis == 1 ? this.props.categories.filter(x => x.isCannabis) : this.props.categories)) : []}
                        />
                    </div> {/* .col */}

                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <DropdownInput
                            name={componentName + "Weight"}
                            fullWidth={true}
                            floatingLabelText={"Weight (G)"}
                            hintText={"Weight (G)"}
                            defaultValue={"0"}
                            options={props.weightOptions && props.weightOptions.length > 0 ? props.weightOptions : []}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <SelectInput
                            name={componentName + "Species"}
                            fullWidth={true}
                            label={"Species"}
                            floatingLabelText={"Species"}
                            hintText={"Species"}
                            defaultValue="0"
                            options={props.speciesOptions && props.speciesOptions.length > 0 ? props.speciesOptions : []}
                        />
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <SelectInput
                            name={componentName + "ShowZeroQuantity"}
                            fullWidth={true}
                            label={"Show Zero Quantity"}
                            floatingLabelText={"Show Zero Quantity"}
                            hintText={"Show Zero Quantity"}
                            defaultValue="0"
                            options={props.showZeroQuantityOptions && props.showZeroQuantityOptions.length > 0 ? props.showZeroQuantityOptions : []}
                        />
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <SelectInput
                            name={componentName + "InventoryCountRange"}
                            fullWidth={true}
                            label={"Inventory Range Filter"}
                            floatingLabelText={"Inventory Range Filter"}
                            hintText={"Inventory Range filter"}
                            defaultValue="0"
                            options={props.inventoryCountRangeOptions && props.inventoryCountRangeOptions.length > 0 ? props.inventoryCountRangeOptions : []}
                        />
                    </div>

                    {this.props.showZeroQuantity == 0 ?
                        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                            <SelectInput
                                name={componentName + "WarehouseType"}
                                fullWidth={true}
                                label={"Warehouse Type"}
                                floatingLabelText={"Warehouse Type"}
                                hintText={"Warehouse Type"}
                                defaultValue="0"
                                options={props.warehouseTypesOptions}
                            />
                        </div> : null
                    }

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 mt-1 mb_xs justify-content-end">
                        <Button
                            type="IconInButton"
                            className="pull-right mt-2 ml-2 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.viewReport.name}
                            label={LOOKUP.report.common.viewReport.label}
                            icon={<VisibilityIcon />}
                            onTouchTap={props.showBody}
                        />
                        <Button
                            type="DownloadButton"
                            className="pull-right mt-2 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.downloadReport.name}
                            label={LOOKUP.report.common.downloadReport.label}
                            onTouchTap={props.download}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <p className="purpleText mt-1"><b>Note: </b><i>The <strong className="danger">"Total Value"</strong> is calculated from available warehouse types(storage, store & damage).
                            <br /> The <strong className="danger">"Latest Unit Cost"</strong> is calculated from all the historical purchase orders in <strong className="danger">all branches</strong> before the selected date for that product.
                            <br /> The Inventory Range Filter is for the Storage Quantity plus the Store Quantity</i></p>
                    </div>
                </div>
            </CardSimple>
        )
    }
}

const mapStateToProps = state => {

    return {
        isCannabis: state.form.InventorySnapShotIsCannabis,
    };
};

export default connect(mapStateToProps)(Header);

